'use strict';

angular.module('shiftTraderApp')
  .directive('saNoteModifyContext', ['$rootScope', 'NotesOverlayContextService', 'WorkPeriodStore', 'TimeService', function ($rootScope, NotesOverlayContextService, WorkPeriodStore, TimeService) {

    function processAttrString(val) {
      if (val === 'null') {
        return null;
      } else if (val === 'undefined') {
        return undefined;
      } else {
        return val;
      }
    }

    return {
      template: '<div class="sa-note-modify-context" ng-transclude></div>',
      transclude: true,
      restrict: 'A',
      link: function(scope, elem, attrs) {
        function processActionString(val) {
          // split on pipe

          var components = val.split('|');

          return {
            rawAction: val,
            actionType: components[0],
            actionValue: (components.length > 1) ? components[1] : undefined
          };
        }

        var state = lodash.merge({
          obj: processAttrString(attrs.obj),
          obj_id: processAttrString(attrs.obj_id)
        }, processActionString(attrs.action));

        $(elem).find('.modify-context-click').on('click touchdown', function() {
          fireAction();
        });


        function fireAction() {
          if (state.actionType === 'changeDay') {
            NotesOverlayContextService.shiftDateContext(parseInt(state.actionValue));
          } else if (state.actionType === 'workPeriod') {
            WorkPeriodStore.getRecordById(parseInt(state.actionValue))
              .then(function(wp) {
                NotesOverlayContextService.setWorkPeriodContext(wp);
              }, function(response) {

              });
          } else if (state.actionType === 'date') {
            NotesOverlayContextService.setDateContext(moment(state.actionValue));
          } else if (state.actionType === 'position') {
            NotesOverlayContextService.setPositionContext(parseInt(state.actionValue));
          } else if (state.actionType === 'user') {
            NotesOverlayContextService.setUserContext(parseInt(state.actionValue));
          } else if (state.actionType === 'today') {
            NotesOverlayContextService.setDateContext(TimeService.getNowInStoreTime());
          } else if (state.actionType === 'home') {
            NotesOverlayContextService.setHomeContext();
          } else if (state.actionType === 'recent') {
            NotesOverlayContextService.setMostRecentContext();
          } else if (state.actionType === 'learn') {
            NotesOverlayContextService.setLearnContext();
          } else if (state.actionType === 'note') {
            NotesOverlayContextService.setNoteContext(parseInt(state.actionValue));
          }

          $rootScope.$broadcast('note-overlay-open');
        }



      }
    };
  }]);
